import React from "react";
import DropDownButton from "devextreme-react/drop-down-button";

const dropDownOptions = { width: 280, height: 120 };

/**
 * Options menu for a grid's own toolbar - the bottom-pane result grids (legacy uOMD0013
 * pmBottomSalesOrder, popped from the navigator's Options button) and the Split Order dialog's
 * detail grid (uOMD0018/uOMD0040 pmOptions). Each grid supplies its own operations; the item
 * ids/labels come from `enum/Enum.js`.
 *
 * The top grid's header-level menu is a different thing — see SalesOrderOptionsButton.
 */
const GridOptionsButton = ({ items, onItemClick, disabled = false }) => (
    <DropDownButton
        icon="fa fa-cogs"
        text="Options"
        stylingMode="text"
        dropDownOptions={dropDownOptions}
        items={items}
        onItemClick={onItemClick}
        displayExpr="name"
        keyExpr="id"
        disabled={disabled}
    />
);

export default GridOptionsButton;
